export default {
  values: {
    default: {
      'DesktopGroupScreen.registry.action.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '0F1MCu2AzXWvPBbjqFfHZl',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '0sZ6naL9Q8mzvZWFeytNgc',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.action': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.action',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '6C8bFRMuP7XirSRlcDA6V7',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '5apuEHp63kv5zpl4akqtuj',
                  type: 'attr.column.string',
                  header: {
                    label: 'Name',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'name',
                  objectType: 'RelayHub.action'
                }, {
                  id: '2vEGM8FUAFREvk0veXKVt5',
                  type: 'attr.column.string',
                  header: {
                    label: 'Trigger',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'trigger',
                  objectType: 'RelayHub.action'
                }, {
                  id: '1lx126wcoMptO4odannOVq',
                  type: 'attr.column.string',
                  header: {
                    label: 'Type',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'type',
                  objectType: 'RelayHub.action'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopGroupScreen.registry.secret.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '45LJvdiNeuBpvhVT1q7wqA',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '5p1MJwL9AH05qEDWrfU8M2',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.secret': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.secret',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '3c10zXSGqqeZOfB50bLkC3',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '3kDLQV6tn8Yr6eOzsFMJct',
                  type: 'attr.column.string',
                  header: {
                    label: 'Name',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'name',
                  objectType: 'RelayHub.secret'
                }, {
                  id: '6f0G4MefACnQUaOsI4vDtt',
                  type: 'attr.column.string',
                  header: {
                    label: 'Description',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'description',
                  objectType: 'RelayHub.secret'
                }, {
                  id: '24fUiZ7m88q6wdNqb7o9NT',
                  type: 'attr.column.string',
                  header: {
                    label: 'ID',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'id',
                  objectType: 'RelayHub.secret'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopItemInfoScreen.registry.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '6nu8CHeLJiYQyO6lfa963X',
          type: 'molten.Dashboard',
          settings: {
            type: 'uiDashboard',
            columns: 2,
            columnSize: '1fr',
            rowGap: '8px',
            columnGap: '8px',
            options: {},
            cards: [{
              type: 'uiDashboardCard',
              title: null,
              icon: null,
              titleVisible: false,
              style: 'grid',
              deletable: true,
              width: 2,
              height: 1,
              providers: {},
              content: {
                type: 'uiDashboardGrid',
                columns: 2,
                columnSize: '1fr',
                rowGap: '8px',
                columnGap: '8px',
                options: {},
                cards: [{
                  type: 'uiDashboardCard',
                  title: 'Details',
                  icon: null,
                  titleVisible: true,
                  style: null,
                  deletable: true,
                  width: 1,
                  height: 1,
                  providers: {},
                  content: {
                    id: '7K2L3iGs6faz1OpjpVv3vU',
                    type: 'molten.dataViewer.dashboard.DataViewerCard',
                    height: 'auto',
                    minHeight: null,
                    maxHeight: null,
                    dataViewer: {
                      id: '5B2TuQskI8b2QgooqTJfZZ',
                      type: 'molten.Details',
                      settings: {
                        type: 'detail.Item',
                        display: 'block',
                        types: {
                          'RelayHub.registry': {
                            type: 'detail.ItemType',
                            objectType: 'RelayHub.registry',
                            display: null,
                            details: {
                              type: 'detail.DetailList',
                              variant: 'item',
                              background: null,
                              labelColor: null,
                              valueColor: null,
                              suffixColor: null,
                              header: {
                                controlsVisible: false,
                                visible: false,
                                primary: {
                                  attrName: 'name',
                                  color: null,
                                  font: {
                                    type: 'style.Font',
                                    family: null,
                                    size: null,
                                    weight: null,
                                    style: null
                                  }
                                },
                                icon: {
                                  attrName: 'icon',
                                  size: '24px'
                                }
                              },
                              footer: {
                                visible: false
                              },
                              details: [{
                                type: 'attr.detail.string',
                                visible: true,
                                label: {
                                  name: 'ID',
                                  visible: true,
                                  color: null,
                                  font: {
                                    type: 'style.Font',
                                    family: null,
                                    size: null,
                                    weight: null,
                                    style: null
                                  },
                                  justify: 'left',
                                  align: 'center',
                                  wrap: false
                                },
                                value: {
                                  color: null,
                                  font: {
                                    type: 'style.Font',
                                    family: null,
                                    size: null,
                                    weight: null,
                                    style: null
                                  },
                                  justify: 'right',
                                  align: 'center',
                                  wrap: false,
                                  showIfEmpty: true,
                                  emptyValue: '-'
                                },
                                columns: 2,
                                attrName: 'id',
                                objectType: 'RelayHub.registry'
                              }, {
                                type: 'attr.detail.string',
                                visible: true,
                                label: {
                                  name: 'Protocols',
                                  visible: true,
                                  color: null,
                                  font: {
                                    type: 'style.Font',
                                    family: null,
                                    size: null,
                                    weight: null,
                                    style: null
                                  },
                                  justify: 'left',
                                  align: 'center',
                                  wrap: false
                                },
                                value: {
                                  color: null,
                                  font: {
                                    type: 'style.Font',
                                    family: null,
                                    size: null,
                                    weight: null,
                                    style: null
                                  },
                                  justify: 'right',
                                  align: 'center',
                                  wrap: false,
                                  showIfEmpty: true,
                                  emptyValue: '-'
                                },
                                columns: 2,
                                attrName: 'protocols',
                                objectType: 'RelayHub.registry'
                              }, {
                                type: 'attr.detail.string',
                                visible: true,
                                label: {
                                  name: 'Algorithm',
                                  visible: true,
                                  color: null,
                                  font: {
                                    type: 'style.Font',
                                    family: null,
                                    size: null,
                                    weight: null,
                                    style: null
                                  },
                                  justify: 'left',
                                  align: 'center',
                                  wrap: false
                                },
                                value: {
                                  color: null,
                                  font: {
                                    type: 'style.Font',
                                    family: null,
                                    size: null,
                                    weight: null,
                                    style: null
                                  },
                                  justify: 'right',
                                  align: 'center',
                                  wrap: false,
                                  showIfEmpty: true,
                                  emptyValue: '-'
                                },
                                columns: 2,
                                attrName: 'alg',
                                objectType: 'RelayHub.registry'
                              }, {
                                type: 'attr.detail.Generic',
                                visible: true,
                                label: {
                                  name: 'Allow Anonymous',
                                  visible: true,
                                  color: null,
                                  font: {
                                    type: 'style.Font',
                                    family: null,
                                    size: null,
                                    weight: null,
                                    style: null
                                  },
                                  justify: 'left',
                                  align: 'center',
                                  wrap: false
                                },
                                value: {
                                  color: null,
                                  font: {
                                    type: 'style.Font',
                                    family: null,
                                    size: null,
                                    weight: null,
                                    style: null
                                  },
                                  justify: 'right',
                                  align: 'center',
                                  wrap: false,
                                  showIfEmpty: true,
                                  emptyValue: '-'
                                },
                                columns: 2,
                                attrName: 'allowAnonymous',
                                objectType: 'RelayHub.registry',
                                formatter: {
                                  type: 'attr.formatter.boolean',
                                  displayTrue: 'True',
                                  displayFalse: 'False',
                                  displayNull: '-',
                                  displayUndefined: '-'
                                }
                              }]
                            }
                          }
                        }
                      }
                    }
                  }
                }, {
                  type: 'uiDashboardCard',
                  title: null,
                  icon: null,
                  titleVisible: false,
                  style: 'grid',
                  deletable: true,
                  width: 1,
                  height: 1,
                  providers: {},
                  content: {
                    type: 'uiDashboardGrid',
                    columns: 1,
                    columnSize: '1fr',
                    rowGap: '8px',
                    columnGap: '8px',
                    options: {},
                    cards: [{
                      type: 'uiDashboardCard',
                      title: 'Public Key',
                      icon: null,
                      titleVisible: true,
                      style: null,
                      deletable: true,
                      width: 1,
                      height: 1,
                      providers: {},
                      content: {
                        id: '0Xv6onvg76W9NghQKhJhae',
                        type: 'molten.dataViewer.dashboard.DataViewerCard',
                        height: 'auto',
                        minHeight: null,
                        maxHeight: null,
                        dataViewer: {
                          id: '27VDvTiJRJeqF4MNFcCkPu',
                          type: 'molten.Details',
                          settings: {
                            type: 'detail.Item',
                            display: 'block',
                            types: {
                              'RelayHub.registry': {
                                type: 'detail.ItemType',
                                objectType: 'RelayHub.registry',
                                display: null,
                                details: {
                                  type: 'detail.DetailList',
                                  variant: 'item',
                                  background: null,
                                  labelColor: null,
                                  valueColor: null,
                                  suffixColor: null,
                                  header: {
                                    controlsVisible: false,
                                    visible: false,
                                    primary: {
                                      attrName: 'name',
                                      color: null,
                                      font: {
                                        type: 'style.Font',
                                        family: null,
                                        size: null,
                                        weight: null,
                                        style: null
                                      }
                                    },
                                    icon: {
                                      attrName: 'icon',
                                      size: '24px'
                                    }
                                  },
                                  footer: {
                                    visible: false
                                  },
                                  details: [{
                                    type: 'attr.detail.string',
                                    visible: true,
                                    label: {
                                      name: 'publicKey',
                                      visible: false,
                                      color: null,
                                      font: {
                                        type: 'style.Font',
                                        family: null,
                                        size: null,
                                        weight: null,
                                        style: null
                                      },
                                      justify: 'left',
                                      align: 'center',
                                      wrap: false
                                    },
                                    value: {
                                      color: null,
                                      font: {
                                        type: 'style.Font',
                                        family: null,
                                        size: null,
                                        weight: null,
                                        style: null
                                      },
                                      justify: 'left',
                                      align: 'center',
                                      wrap: false,
                                      showIfEmpty: true,
                                      emptyValue: '-'
                                    },
                                    columns: 2,
                                    attrName: 'publicKey',
                                    objectType: 'RelayHub.registry'
                                  }],
                                  evenRowBackground: 'white',
                                  oddRowBackground: 'white'
                                }
                              }
                            }
                          }
                        }
                      }
                    }]
                  }
                }]
              }
            }]
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopGroupScreen.registry.device.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '2oJORZz7KeNyPojEKet1hx',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '0pd3jl0m4hqCnJg9Zpz71B',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.device': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.device',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '496dCU2yfC3WW6B8Tl1h71',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '5RQMWgWwESK3WGsHBYnASy',
                  type: 'attr.column.string',
                  header: {
                    label: 'Device ID',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'id',
                  objectType: 'RelayHub.device'
                }, {
                  id: '4xwqjFCOpfE9mSRnP5Sj8K',
                  type: 'attr.column.object',
                  header: {
                    label: 'State',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'state',
                  objectType: 'RelayHub.device'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopGroupScreen.registry.deviceGroup.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '7Hlhcbz2B0NQ8ylFcOAG56',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '2eIkov3RdtimB6cDOFa0DU',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.deviceGroup': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.deviceGroup',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '28zBSPWpsGMVAPSqw27PtJ',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '4dB62ApdcQyms4d52UZmki',
                  type: 'attr.column.string',
                  header: {
                    label: 'ID',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'id',
                  objectType: 'RelayHub.deviceGroup'
                }, {
                  id: '0f4rGXjbN7oytUYfMXc1wN',
                  type: 'attr.column.string',
                  header: {
                    label: 'Description',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'description',
                  objectType: 'RelayHub.deviceGroup'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopGroupScreen.registry.deviceGroup.device.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '1bfAdUOYpOkVRvZOuLAqvB',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '0LNGP27JBUNEOgREWDSPlW',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.device': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.device',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '1UKi5IqLpeV96ciTDSdejK',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '4J5d0HKCX4ed0cNzTHDfGa',
                  type: 'attr.column.string',
                  header: {
                    label: 'ID',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'id',
                  objectType: 'RelayHub.device'
                }, {
                  id: '1Hx3BS2lGm7ByLcIzXtVY3',
                  type: 'attr.column.object',
                  header: {
                    label: 'State',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'state',
                  objectType: 'RelayHub.device'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopGroupScreen.registry.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '22QQDLL9hsHyXfNvRWCth8',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '75V4YskT7uO6alN0WJo0V1',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.registry': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.registry',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '0jigcvVeAm1AQCHuVAhWjS',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '735tQAuFF5CugFbxZ82KNv',
                  type: 'attr.column.string',
                  header: {
                    label: 'Registry ID',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'id',
                  objectType: 'RelayHub.registry'
                }, {
                  id: '4fSCdKVNO2vk53zTmTwJiK',
                  type: 'attr.column.Generic',
                  header: {
                    label: 'Allow Anonymous',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'allowAnonymous',
                  objectType: 'RelayHub.registry',
                  formatter: {
                    type: 'attr.formatter.boolean',
                    displayTrue: 'true',
                    displayFalse: 'false',
                    displayNull: 'null',
                    displayUndefined: 'undefined'
                  }
                }, {
                  id: '7JmU6G93Lzv0uU4kOPWuFv',
                  type: 'attr.column.string',
                  header: {
                    label: 'Created',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'createdAt',
                  objectType: 'RelayHub.registry'
                }, {
                  id: '4B6QAiPNEvDGfOcosEOKTR',
                  type: 'attr.column.string',
                  header: {
                    label: 'Updated',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'updatedAt',
                  objectType: 'RelayHub.registry'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopItemInfoScreen.registry.action.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '2FlUveVdZy0HUSHMYp3cDn',
          type: 'molten.Dashboard',
          settings: {
            type: 'uiDashboard',
            columns: 2,
            columnSize: '1fr',
            rowGap: '8px',
            columnGap: '8px',
            options: {},
            cards: [{
              type: 'uiDashboardCard',
              title: null,
              icon: null,
              titleVisible: false,
              style: null,
              deletable: true,
              width: 1,
              height: 1,
              providers: {},
              content: {
                id: '7vCAx7rTILx5ic1h44BMFg',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: '300px',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '0A0zMzQTC7DS4uYiG3xoev',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.action': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.action',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Name',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'name',
                            objectType: 'RelayHub.action'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'ID',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'id',
                            objectType: 'RelayHub.action'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Type',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'type',
                            objectType: 'RelayHub.action'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Trigger',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'trigger',
                            objectType: 'RelayHub.action'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }, {
              type: 'uiDashboardCard',
              title: 'Config',
              icon: null,
              titleVisible: true,
              style: null,
              deletable: true,
              width: 2,
              height: 1,
              providers: {},
              content: {
                id: '0pZx3Qa8kLrbWwxN3r6olC',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: 'auto',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '0LapnokLApPKaFXoieI5Dm',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.action': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.action',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.object',
                            visible: true,
                            label: {
                              name: 'config',
                              visible: false,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'config',
                            objectType: 'RelayHub.action'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }]
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopItemInfoScreen.registry.device.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '3qI9BHXguAseHRIA1mkb7N',
          type: 'molten.Dashboard',
          settings: {
            type: 'uiDashboard',
            columns: 2,
            columnSize: '1fr',
            rowGap: '8px',
            columnGap: '8px',
            options: {},
            cards: [{
              type: 'uiDashboardCard',
              title: 'Device Info',
              icon: null,
              titleVisible: true,
              style: null,
              deletable: true,
              width: 2,
              height: 2,
              providers: {},
              content: {
                id: '3DmIDQF1HFQjGBsSQkNdu8',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: '300px',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '7p5v0RpZ6FdF6qm5ppQEty',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.device': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.device',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Device ID',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'id',
                            objectType: 'RelayHub.device'
                          }, {
                            type: 'attr.detail.object',
                            visible: true,
                            label: {
                              name: 'Metadata',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'metadata',
                            objectType: 'RelayHub.device'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Signing Algorithm',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'alg',
                            objectType: 'RelayHub.device'
                          }, {
                            type: 'attr.detail.Generic',
                            visible: true,
                            label: {
                              name: 'Key Expiration',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'keyExpiry',
                            objectType: 'RelayHub.device',
                            formatter: {
                              type: 'attr.formatter.int',
                              unset: '',
                              prefix: null,
                              suffix: null,
                              localize: true,
                              mapping: {}
                            }
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Created',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'createdAt',
                            objectType: 'RelayHub.device'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Updated',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'updatedAt',
                            objectType: 'RelayHub.device'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }, {
              type: 'uiDashboardCard',
              title: 'Device State',
              icon: null,
              titleVisible: true,
              style: null,
              deletable: true,
              width: 1,
              height: 1,
              providers: {},
              content: {
                id: '7xqTVaMHs8JDaWc5aFKvM5',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: 'auto',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '2QT92tyn9pL9kghayblup2',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.device': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.device',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.object',
                            visible: true,
                            label: {
                              name: 'state',
                              visible: false,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'state',
                            objectType: 'RelayHub.device'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }, {
              type: 'uiDashboardCard',
              title: 'Desired State',
              icon: null,
              titleVisible: true,
              style: null,
              deletable: true,
              width: 1,
              height: 1,
              providers: {},
              content: {
                id: '29nG7hqKDnOKAWpxhrgfaY',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: 'auto',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '2wu7H4ZYcIQ5yMYSgeVyTY',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.device': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.device',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.object',
                            visible: true,
                            label: {
                              name: 'Desired State',
                              visible: false,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'desiredState',
                            objectType: 'RelayHub.device'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }]
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopGroupScreen.user.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '3zZrAA1U09IVpcT9CS0KN5',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '4yBmeNfzbtLm5MkjZdXEBO',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.user': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.user',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '7l5f4dNmVJdyA6yKJdBoB8',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '0ZrXWq2OQLcTZed1sl7o8Y',
                  type: 'attr.column.string',
                  header: {
                    label: 'Username',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'username',
                  objectType: 'RelayHub.user'
                }, {
                  id: '6P91yvct4OKU6rPvfLaN2x',
                  type: 'attr.column.string',
                  header: {
                    label: 'Email',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'email',
                  objectType: 'RelayHub.user'
                }, {
                  id: '5PCt0l2rDs0Ow3H98Dcpep',
                  type: 'attr.column.string',
                  header: {
                    label: 'Name',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'name',
                  objectType: 'RelayHub.user'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopItemInfoScreen.billingAccount.registry.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '3EDIM1J3brbUoj2GnHrtTn',
          type: 'molten.Dashboard',
          settings: {
            type: 'uiDashboard',
            columns: 2,
            columnSize: '2fr',
            rowGap: '8px',
            columnGap: '8px',
            options: {},
            cards: [{
              type: 'uiDashboardCard',
              title: null,
              icon: null,
              titleVisible: false,
              style: null,
              deletable: true,
              width: 1,
              height: 1,
              providers: {},
              content: {
                id: '6Z8UTBfGKssJoVjOqBXuXg',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: '300px',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '6nDDrSzkKNgTNa8DWwGQ9f',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.registry': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.registry',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Registry ID',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'id',
                            objectType: 'RelayHub.registry'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Created',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'createdAt',
                            objectType: 'RelayHub.registry'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Updated',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'updatedAt',
                            objectType: 'RelayHub.registry'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }]
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopGroupScreen.connector.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '1GBHKdEPNh4Z71kN86gZOI',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '2talcWe7IougM0lDNqPjzt',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.connector': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.connector',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '0xGKPDfbm8QUwiNMY5dshW',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '1mzA6VA6F1TjaVyjvQYueP',
                  type: 'attr.column.string',
                  header: {
                    label: 'id',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'id',
                  objectType: 'RelayHub.connector'
                }, {
                  id: '6tx5yvPIcK0NiJ0M6tLX5a',
                  type: 'attr.column.string',
                  header: {
                    label: 'type',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'type',
                  objectType: 'RelayHub.connector'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopGroupScreen.billingAccount.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '7Kus27dmiB31VVyPw9NjBx',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '21Bl0hs8nzRs717h6NiTB7',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.billingAccount': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.billingAccount',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '7CsjEXYLf80tDy9gdr1fds',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '1AbDTA6bDAsYF7jT7qR59N',
                  type: 'attr.column.string',
                  header: {
                    label: 'Name',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'name',
                  objectType: 'RelayHub.billingAccount'
                }, {
                  id: '0a5ASKwQvvJUUGLi7sXxs5',
                  type: 'attr.column.string',
                  header: {
                    label: 'External ID',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'externalId',
                  objectType: 'RelayHub.billingAccount'
                }, {
                  id: '0MUKzfTOVWKekb4MktSNQ5',
                  type: 'attr.column.string',
                  header: {
                    label: 'Billing Account ID',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'id',
                  objectType: 'RelayHub.billingAccount'
                }, {
                  id: '1paGTclZBgvFxVF4FsDWv2',
                  type: 'attr.column.string',
                  header: {
                    label: 'Description',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'description',
                  objectType: 'RelayHub.billingAccount'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopItemInfoScreen.billingAccount.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '4Osov6b6VKAmAF0VShpLf6',
          type: 'molten.Dashboard',
          settings: {
            type: 'uiDashboard',
            columns: 2,
            columnSize: '1fr',
            rowGap: '8px',
            columnGap: '8px',
            options: {},
            cards: [{
              type: 'uiDashboardCard',
              title: null,
              icon: null,
              titleVisible: false,
              style: null,
              deletable: true,
              width: 2,
              height: 1,
              providers: {},
              content: {
                id: '7itwtXcCe7vK8luTfRmm0r',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: '300px',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '1bCaOrnwpbigkrb5qVF3JI',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.billingAccount': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.billingAccount',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Name',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'name',
                            objectType: 'RelayHub.billingAccount'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'External ID',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'externalId',
                            objectType: 'RelayHub.billingAccount'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Connect Billing ID',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'id',
                            objectType: 'RelayHub.billingAccount'
                          }, {
                            type: 'attr.detail.object',
                            visible: true,
                            label: {
                              name: 'Account Info',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'metadata',
                            objectType: 'RelayHub.billingAccount'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Account Type',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'type',
                            objectType: 'RelayHub.billingAccount'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }]
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopGroupScreen.billingAccount.registry.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '0XnDf6Kgwi0UyF1VmVBUQl',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '5j5JVZy0U7SqQ6kvoEVO3p',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.registry': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.registry',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '3mVLHDPW5jjsGat7i8jJiJ',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '2HmqEoHxt9cpXX291kewcE',
                  type: 'attr.column.string',
                  header: {
                    label: 'Registry ID',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'id',
                  objectType: 'RelayHub.registry'
                }, {
                  id: '5eC4TWHQzI9x6vapRri0Ex',
                  type: 'attr.column.string',
                  header: {
                    label: 'Created',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'createdAt',
                  objectType: 'RelayHub.registry'
                }, {
                  id: '4qxtJNpYZX2PwxqiDv2YJS',
                  type: 'attr.column.string',
                  header: {
                    label: 'Updated',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'updatedAt',
                  objectType: 'RelayHub.registry'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopItemInfoScreen.connector.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '4i1Rul7QxLqWlStVqOQuFS',
          type: 'molten.Dashboard',
          settings: {
            type: 'uiDashboard',
            columns: 2,
            columnSize: '1fr',
            rowGap: '8px',
            columnGap: '8px',
            options: {},
            cards: [{
              type: 'uiDashboardCard',
              title: null,
              icon: null,
              titleVisible: false,
              style: null,
              deletable: true,
              width: 1,
              height: 1,
              providers: {},
              content: {
                id: '59uOIRaf0xiafKYC9lgUZ6',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: '300px',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '5wQH4hAWyyegwpeSvLqdU4',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.connector': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.connector',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'id',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'id',
                            objectType: 'RelayHub.connector'
                          }, {
                            type: 'attr.detail.object',
                            visible: true,
                            label: {
                              name: 'config',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'config',
                            objectType: 'RelayHub.connector'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'type',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'type',
                            objectType: 'RelayHub.connector'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'publicKey',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'publicKey',
                            objectType: 'RelayHub.connector'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }]
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopItemInfoScreen.registry.deviceGroup.action.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '02Xnne3fJbmBHTefaRgF9W',
          type: 'molten.Dashboard',
          settings: {
            type: 'uiDashboard',
            columns: 2,
            columnSize: '1fr',
            rowGap: '8px',
            columnGap: '8px',
            options: {},
            cards: [{
              type: 'uiDashboardCard',
              title: null,
              icon: null,
              titleVisible: false,
              style: null,
              deletable: true,
              width: 1,
              height: 1,
              providers: {},
              content: {
                id: '7gMW3GuWrY0IOK5KepgLSA',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: '300px',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '4yRLVFLhzBRRl4aC7rQquU',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.action': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.action',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Name',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'name',
                            objectType: 'RelayHub.action'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Action ID',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'id',
                            objectType: 'RelayHub.action'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Trigger',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'trigger',
                            objectType: 'RelayHub.action'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Type',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'type',
                            objectType: 'RelayHub.action'
                          }, {
                            type: 'attr.detail.object',
                            visible: true,
                            label: {
                              name: 'Config',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'config',
                            objectType: 'RelayHub.action'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }]
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopGroupScreen.registry.deviceGroup.secret.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '2SEhLhvsc70Rl92PM6NnPp',
          type: 'molten.TableList',
          settings: {
            type: 'molten.dataViewer.responsive.ResponsiveModel',
            dataViewers: [{
              id: '2YkRE4ZPyyfLdoCOGYO53B',
              type: 'molten.List',
              settings: {
                type: 'detail.Item',
                display: 'block',
                types: {
                  'RelayHub.secret': {
                    type: 'detail.ItemType',
                    objectType: 'RelayHub.secret',
                    display: null,
                    details: {
                      type: 'detail.DetailList',
                      variant: 'item',
                      background: null,
                      labelColor: null,
                      valueColor: null,
                      suffixColor: null,
                      header: {
                        controlsVisible: false,
                        visible: false,
                        primary: {
                          attrName: 'name',
                          color: null,
                          font: {
                            type: 'style.Font',
                            family: null,
                            size: null,
                            weight: null,
                            style: null
                          }
                        },
                        icon: {
                          attrName: 'icon',
                          size: '24px'
                        }
                      },
                      footer: {
                        visible: false
                      },
                      details: []
                    }
                  }
                }
              }
            }, {
              id: '1Dt8FbYE5zsLMtE7YWQV0L',
              type: 'molten.Table',
              settings: {
                type: 'table.TableModel',
                columns: [{
                  id: '4NHNxZZ97kKZWeXYeUwHmr',
                  type: 'attr.column.string',
                  header: {
                    label: 'Name',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'name',
                  objectType: 'RelayHub.secret'
                }, {
                  id: '0mZzegodROVfdtjmUcemYa',
                  type: 'attr.column.string',
                  header: {
                    label: 'Secret ID',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'id',
                  objectType: 'RelayHub.secret'
                }, {
                  id: '2zd1rbOLTirAh6BH63iLU5',
                  type: 'attr.column.string',
                  header: {
                    label: 'Created',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'createdAt',
                  objectType: 'RelayHub.secret'
                }, {
                  id: '2D2E5EAmAY3C2T2R87Mz8b',
                  type: 'attr.column.string',
                  header: {
                    label: 'Updated',
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'left',
                    align: 'center',
                    wrap: false,
                    background: null
                  },
                  width: null,
                  minWidth: null,
                  maxWidth: null,
                  cell: {
                    color: null,
                    font: {
                      type: 'style.Font',
                      family: null,
                      size: null,
                      weight: null,
                      style: null
                    },
                    justify: 'right',
                    align: 'center',
                    wrap: false,
                    emptyValue: null,
                    background: null
                  },
                  attrName: 'updatedAt',
                  objectType: 'RelayHub.secret'
                }],
                selectable: true
              }
            }],
            breakpoints: ['minWidth']
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopItemInfoScreen.registry.deviceGroup.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '6UaXkdGeoqrzf1X1VFD7rR',
          type: 'molten.Dashboard',
          settings: {
            type: 'uiDashboard',
            columns: 2,
            columnSize: '1fr',
            rowGap: '8px',
            columnGap: '8px',
            options: {},
            cards: [{
              type: 'uiDashboardCard',
              title: null,
              icon: null,
              titleVisible: false,
              style: null,
              deletable: true,
              width: 1,
              height: 1,
              providers: {},
              content: {
                id: '63WBjN7pqlRWY7lJZS7lp0',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: '300px',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '67ZSI6Hx3FAhI7VFUQKuNb',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.deviceGroup': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.deviceGroup',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Device Group ID',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'id',
                            objectType: 'RelayHub.deviceGroup'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Description',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'description',
                            objectType: 'RelayHub.deviceGroup'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }]
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      },
      'DesktopItemInfoScreen.registry.secret.LayoutModel': {
        type: 'molten.dataViewers.LayoutModel',
        version: 2,
        layout: 'vh',
        main1: {
          id: '5c6zdOLSxGNIyqe3RSXZG2',
          type: 'molten.Dashboard',
          settings: {
            type: 'uiDashboard',
            columns: 2,
            columnSize: '1fr',
            rowGap: '8px',
            columnGap: '8px',
            options: {},
            cards: [{
              type: 'uiDashboardCard',
              title: null,
              icon: null,
              titleVisible: false,
              style: null,
              deletable: true,
              width: 1,
              height: 1,
              providers: {},
              content: {
                id: '413CCQXFJT2QK9G5QzgS5v',
                type: 'molten.dataViewer.dashboard.DataViewerCard',
                height: '300px',
                minHeight: null,
                maxHeight: null,
                dataViewer: {
                  id: '7qFH8sQSpRsD4n9z3CCbdz',
                  type: 'molten.Details',
                  settings: {
                    type: 'detail.Item',
                    display: 'block',
                    types: {
                      'RelayHub.secret': {
                        type: 'detail.ItemType',
                        objectType: 'RelayHub.secret',
                        display: null,
                        details: {
                          type: 'detail.DetailList',
                          variant: 'item',
                          background: null,
                          labelColor: null,
                          valueColor: null,
                          suffixColor: null,
                          header: {
                            controlsVisible: false,
                            visible: false,
                            primary: {
                              attrName: 'name',
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              }
                            },
                            icon: {
                              attrName: 'icon',
                              size: '24px'
                            }
                          },
                          footer: {
                            visible: false
                          },
                          details: [{
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Name',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'name',
                            objectType: 'RelayHub.secret'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Secret ID',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'id',
                            objectType: 'RelayHub.secret'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Description',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'description',
                            objectType: 'RelayHub.secret'
                          }, {
                            type: 'attr.detail.string',
                            visible: true,
                            label: {
                              name: 'Value',
                              visible: true,
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'left',
                              align: 'center',
                              wrap: false
                            },
                            value: {
                              color: null,
                              font: {
                                type: 'style.Font',
                                family: null,
                                size: null,
                                weight: null,
                                style: null
                              },
                              justify: 'right',
                              align: 'center',
                              wrap: false,
                              showIfEmpty: true,
                              emptyValue: '-'
                            },
                            columns: 2,
                            attrName: 'value',
                            objectType: 'RelayHub.secret'
                          }]
                        }
                      }
                    }
                  }
                }
              }
            }]
          }
        },
        main2: null,
        aux1: null,
        aux2: null,
        aux3: null,
        aux4: null,
        topLeft: 'aux1',
        topRight: 'aux1',
        bottomLeft: 'aux2',
        bottomRight: 'aux2'
      }
    }
  }
};